export default "<input class=\"search-location\" type=\"text\" [(ngModel)]=\"autocompleteInput\" #addressText />\n";